import React from "react";
import { Link } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Layout from "../inc/layout-frontend";

export default function Confirmation(){
    return(
        <Layout> 
        {/** Navbar Start */}
  <div className="container-fluid position-relative p-0">
              <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom:"90px" }}>
          <div className="row py-5">
              <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                  <h1 className="display-4 text-white animated zoomIn">Paiement</h1>
                  <Link className="h5"  style={{ color:"goldenrod"}} to={myroutes.homepage}>
                  Accueil
                  </Link>
                  <i className="far fa-circle text-white px-2"></i>
                  <Link className="h5 text-white" >
                     Confirmation de paiement
                  </Link>
              </div>
          </div>
      </div>
  </div>
  {/** Navbar End */}
  <section class="page-wrapper success-msg">
  <div class="container">
    <div class="row">
      <div class="col-md-2">&nbsp;</div>
      <div class="col-md-8 col-md-offset-3">
        <div class="block text-center">
          <i class="tf-ion-android-checkmark-circle"></i>
          <h2 class="text-center">Merci à vous pour votre paiement !</h2><br />
          <p>Nous allons procéder à la validation de votre paiement dans les plus bref délais</p><br />
          <Link to={myroutes.homepage} class="btn btn-warning btn-main mt-20 me-2">Continuer votre achat</Link>
          <Link to={myroutes.moncompte} class="btn btn-primary mt-20 " >Mon Compte</Link>
        </div>
      </div>
      <div class="col-md-2">&nbsp;</div>
    </div>
  </div>
</section>

  </Layout>
    )
}